export default {
  title: {
    login: 'Login',
    createPassword: 'Create your Password',
    forgetPassword: 'Forgot Password',
    resetPassword: 'Reset Password',
    questionnaire: 'Satisfaction Survey',
    alert: 'Please Check Your Email ',
    statement: 'Privacy Consent Statement'
  },
  btn: {
    home: 'Home',
    forgetPassword: 'forgot password',
    reset: 'Reset',
    confirm: 'Confirm',
    upload: 'Upload',
    addEntry: 'Add',
    remove: 'Remove',
    back: 'Back',
    cancel: 'Cancel',
    next: 'Next',
    finish: 'Finish',
    submit: 'Submit',
    viewJobs: 'View all jobs',
    viewResume: 'View resume',
    viewApplicant: 'View application status',
    viewHMDashboard: 'View HM dashboard'
  },
  label: {
    year: '{year} ',
    language: 'Language',
    email: 'Email',
    userName: 'User Name',
    firstName: 'First Name',
    lastName: 'Last Name',
    password: 'Password',
    reEnterPassword: 'Re-Enter Password',
    agreeStatement: "I've read & accept the Data Privacy Consent Statement",
    toEmployeePortal: 'Go To Employee Portal',
    statementBody: '',
    thanksLabel: 'Thanks!',
    finishContent: 'Your {questionnaire} has been successfully submitted, good luck!',
    moreInformation: 'More Information:',
    scanToFollowWeChat: 'Follow us on WeChat!',
    followWeChat: 'Follow us on WeChat',
    followWeChatDesc: 'Receive updates about your application get the latest career news.',
    toWeChat: 'Go >',
    present: 'Now',
    entryNo: 'Entry {number}',
    startDate: 'Start Date',
    endDate: 'End Date',
    status: 'Status',
    pending: 'Pending',
    submitted: 'Submitted',
    cancelled: 'Cancelled',
    noData: 'No data',
    configMissing: 'Configuration missing',
    step: 'Step',
    confirmed: 'Confirmed',
    unconfirmed: 'Not confirmed',
    signature: 'Signature',
    clickToSign: 'Click to sign',
    resign: 'Sign again',
    jobApplication: 'Job Application Form',
    jobApplicationRecord: 'Job Application Record',
    operationRecords: 'Operation Records',
    jobApplicationInviteRecord: '{name} invited the job application form at {time}',
    jobApplicationReminderRecord: '{name} sent a job application reminder at {time}',
    jobApplicationCompleteRecord: '{name} completed the job application form at {time}',
    jobApplicationReactivateRecord: '{name} reactivated at {time}, reason: {reason}',
    jobApplicationStatusInvited: 'Job application invited',
    jobApplicationStatusReminded: 'Job application reminded',
    jobApplicationStatusCompleted: 'Job application completed',
    jobApplicationStatusReactivated: 'Job application reactivated'
  },
  message: {
    resetEmailSuccess: 'A password re-set email has been sent to your email account. Please check your email account to continue with the login process.',
    wrongEmail: 'Unable to reset the password, please check the email address.',
    questionnaireFinished: 'Questionnaire Finished',
    questionnaireFinishedText1: 'Congratulations on completing all the questions',
    questionnaireStepZeroText1: 'Please fill out the information on the following wizards.',
    questionnaireStepZeroText2: 'Use buttons on the bottom of wizard for navigation.',
    questionnaireStepZeroText3: 'Press "Cancel" to get back to questionnaire, previously entered information will be saved.',
    fileChangedButNoUpload: 'The file has been modified but not uploaded. Are you sure you want to leave?'
  },
  error: {
    passwordNotSame: 'Two passwords are not same',
    fileNotUpload: 'Attachment is required',
    fileSize: 'File size can not exceed 4MB',
    isRequired: 'This field cannot be empty',
    login: 'Your username or password is incorrect',
    passwordTip: 'Password must contain small letter, capital letter and number, and at least 10 digit, symbol can only use _#@.-',
    noSteps: 'Get no questionnaire steps, please refresh and try again',
    uploadError: 'Upload file failed, please try again',
    uploadSuccess: 'Upload file successfully',
    phoneError: 'Phone number format is invalid',
    birthIsNeeded: 'Date of Birth is required.',
    ageTooSmall: 'You have indicated that you are under the age of 15. You must be at least 15 years old to work for our company.',
    nameNotEn: 'Please check and ensure your name is in Pinyin or English before click to next page',
    nationalIDIssueDateIsNeeded: 'National ID issue date is required.',
    nationalIDExpireDateIsNeeded: 'National ID expiry date is required.',
    nationalIDExpireLargeThanIssue: 'National ID issue date should be less than expiry date.',
    nationalIDExpireLargeThanNow: 'National ID expiry date should be in future.',
    nationalIDRegex: 'Please enter a valid {nationID}. Use The Format {format}',
    mustSelected: 'This field must be selected',
    tryAgain: 'Please try again',
    minRows: 'Please add at least {count} entries',
    signatureRequired: 'Please provide your signature',
    signatureUploadFailed: 'Signature upload failed. Please try again.'
  }
}
